// @flow
// $FlowFixMe
import 'babel-polyfill'
// $FlowFixMe
import * as Sentry from '@sentry/browser'
import React from 'react'
import ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'

import Root from 'src/components/Root'
import { store } from 'src/config/store'

import { unregister } from './registerServiceWorker'
unregister()

process.env.NODE_ENV !== 'development' &&
  Sentry.init({
    dsn:
      process.env.REACT_APP_SENTRY_DSN ||
      'https://a8c7c048d3f84f57b3f8d51dfe443169@sentry.io/1413696'
  })

const root: ?Element = document.getElementById('root')

if (root != null) {
  ReactDOM.render(<Root store={store} />, root)
  registerServiceWorker()
}



// WEBPACK FOOTER //
// ./src/index.js